<template>
  <div>
    <vs-button
      icon-pack="feather"
      icon="icon-mail"
      size="small"
      type="gradient"
      color="success"
      class="mr-2"
      @click="activePopup = true"
    >
      <span v-if="this.$store.state.windowWidth > this.$store.state.windowsNavMin">
        {{ $t('comments.comments') }}
      </span>
    </vs-button>
    <vs-popup :title="$t('comments.send_comment')" :active.sync="activePopup">
      <div class="vs-con-loading__container" id="upload-with-loading">
        <div class="text-white bg-success-gradient p-4 mb-4 rounded">{{ $t('comments.header_alert') }}</div>
        <div class="w-full">
          <label class="vs-input--label">{{ $t('comments.type') }}</label>
          {{ $t('asd.asd') }}
          <v-select
            v-model="comment.type"
            :clearable="false"
            :options="typeOptions"
            :reduce="option => option.value"
            name="type"
            v-validate="'required'"
            :data-vv-as="$t('comments.type')"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
          <span class="text-danger text-sm" v-show="errors.has('type')">{{ errors.first('type') }}</span>
        </div>
        <div class="w-full mb-5">
          <label class="vs-input--label">{{ $t('comments.description') }}</label>
          <vs-textarea
            name="description"
            v-model="comment.description"
            v-validate="'required'"
            :data-vv-as="$t('comments.description')"
            class="w-full mb-0"
          />
          <span class="text-danger text-sm" v-show="errors.has('description')">{{
            errors.first('description')
          }}</span>
        </div>
        <div class="w-full mb-5" v-if="comment.attachments.length">
          <span>{{ $t('comments.attachments') }}: {{ comment.attachments.length }}</span>
        </div>
        <input type="file" ref="upload_input" @change="uploadFile" class="hidden" accept="image/*" />
        <vs-row vs-justify="flex-end">
          <vs-button
            class="mr-2"
            @click="comment.attachments = []"
            color="danger"
            type="border"
            v-if="comment.attachments.length"
          >
            {{ $t('comments.delete_attachments') }}
          </vs-button>
          <vs-button class="vs-con-loading__container mr-2" @click="$refs.upload_input.click()">
            {{ $t('button.file_upload') }}
          </vs-button>
          <vs-button
            id="button-with-loading"
            color="success"
            class="vs-con-loading__container mr-2"
            @click="addComment"
          >
            {{ $t('forms.submit') }}
          </vs-button>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moduleComment from '@/store/comment/moduleComment'

export default {
  name: 'Comment',
  data() {
    return {
      comment: { attachments: [] },
      activePopup: false
    }
  },
  computed: {
    typeOptions() {
      return this.$store.getters['enum/selectOptions']('CommentType', 'comments.types')
    }
  },
  methods: {
    uploadFile(event) {
      this.$vs.loading({
        container: '#upload-with-loading',
        scale: 0.45
      })
      this.$store.dispatch('file/uploadFile', event).then(response => {
        this.comment.attachments.push(response.data[0].id)
        this.$vs.loading.close('#upload-with-loading > .con-vs-loading')
      })
    },
    addComment() {
      this.comment.route = this.$route.fullPath
      this.comment.data = {
        errors: { ...this.errors },
        screen: { width: screen.width, height: screen.height, orientation_type: screen.orientation.type },
        navigator: { language: navigator.language, userAgent: navigator.userAgent }
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading({
            background: 'success',
            container: '#button-with-loading',
            color: '#fff',
            scale: 0.45
          })
          this.$store
            .dispatch('comment/createComment', this.comment)
            .then(() => {
              this.comment = { attachments: [] }
              this.$notifySuccess(this.$t('comments.successfully_created'))
            })
            .finally(() => {
              this.activePopup = false
              this.$vs.loading.close('#button-with-loading > .con-vs-loading')
            })
        }
      })
    }
  },
  created() {
    if (!moduleComment.isRegistered) {
      this.$store.registerModule('comment', moduleComment)
      moduleComment.isRegistered = true
    }
  }
}
</script>

<style scoped></style>
